import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { CollectionService } from "../../collections/collection.service";

@Component({
  selector: "app-upload-csv-modal",
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: "./upload-csv-modal.component.html",
  styleUrl: "./upload-csv-modal.component.scss"
})
export class UploadCsvModalComponent {
  selectedFile: File | null = null;
  fileError: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private collectionService: CollectionService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (!file) {
      this.fileError = false;
      this.selectedFile = null;
      return;
    }

    const isCsv =
      file.type === "text/csv" ||
      file.name.toLowerCase().endsWith(".csv")||
      file.name.toLowerCase().endsWith(".txt");

    if (isCsv) {
      this.selectedFile = file;
      this.fileError = false;
    } else {
      this.selectedFile = null;
      this.fileError = true;
      event.target.value = null;
    }
  }

  upload() {
    if (!this.selectedFile) return;

    const formData = new FormData();
    formData.append("file", this.selectedFile);

    this.collectionService.sendCsv(formData).subscribe({
      next: (response: any) => {
        if (response.success) {
          const successMsg = this.translate.instant("success.csv_uploaded");
          this.toastr.success(successMsg, "", {
            positionClass: "toast-bottom-left",
            tapToDismiss: true,
          });

          this.activeModal.close(true);
        }
      },
    });
  }

  close() {
    this.activeModal.dismiss();
  }
}
